import { render, staticRenderFns } from "./BookScroll.vue?vue&type=template&id=228803ad&scoped=true&"
import script from "./BookScroll.vue?vue&type=script&lang=js&"
export * from "./BookScroll.vue?vue&type=script&lang=js&"
import style0 from "./BookScroll.vue?vue&type=style&index=0&id=228803ad&lang=scss&scoped=true&"
import style1 from "./BookScroll.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228803ad",
  null
  
)

export default component.exports